<div *ngIf="show" class="full-screen">
  <mat-spinner class="spinner" color="accent"></mat-spinner>
</div>
